import { useForm } from '@mantine/form'
import { Button, Flex, LoadingOverlay, Paper, TextInput } from '@mantine/core'
import { Link, useNavigate } from 'react-router-dom'
import {
    IRequestUpdateUserPosition,
    IResponseGetUserPositionByID,
} from '@interfaces/api/IUserPosition'
import UserPosition from '@api/UserPosition'

const FormEditUserPosition = ({
    aftersuccess,
    data,
}: {
    aftersuccess?: () => any
    data: IResponseGetUserPositionByID
}) => {
    const form = useForm<IRequestUpdateUserPosition>({
        initialValues: {
            user_position_name: data.user_position_name,
        },
    })
    const navigate = useNavigate()

    const { isLoading, onSubmit } = UserPosition.useUpdateUserPosition({
        user_position_id: data.user_position_id,
        form,
        aftersuccess: () => navigate('/users#user_position'),
    })

    return (
        <Paper pos='relative'>
            <LoadingOverlay visible={isLoading} overlayBlur={2} />
            <form onSubmit={onSubmit}>
                <Flex gap='sm' direction='column'>
                    <TextInput
                        withAsterisk
                        label='ชื่อตำแหน่ง'
                        placeholder='ชื่อตำแหน่ง'
                        {...form.getInputProps('user_position_name')}
                    />
                    <Flex mt='md' justify='end' gap='sm'>
                        <Button
                            component={Link}
                            to='/users#user_position'
                            variant='default'
                            w='fit-content'
                        >
                            ยกเลิก
                        </Button>
                        <Button type='submit' w='fit-content'>
                            บันทึกการแก้ไขตำแหน่ง
                        </Button>
                    </Flex>
                </Flex>
            </form>
        </Paper>
    )
}

export default FormEditUserPosition
